import { useMsal } from "@azure/msal-react";
import { Avatar, Button, Flex, Link, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import SignOutButton from "./SignOutButton";

const NavBar = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [userPhoto, setUserPhoto] = useState<string | undefined>();

  useEffect(() => {
    const fetchPhoto = async () => {
      // Ensure you handle multiple accounts appropriately
      if (!activeAccount) return;

      // Request to get access token
      const accessTokenResponse = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: activeAccount,
      });

      // Use token to fetch photo from Microsoft Graph API
      const response = await fetch(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${accessTokenResponse.accessToken}`,
          },
        }
      );

      if (response.ok) {
        const imageBlob = await response.blob();
        const imageUrl = URL.createObjectURL(imageBlob);
        setUserPhoto(imageUrl);
      }
    };
    fetchPhoto();
  }, [instance]);

  return (
    <Flex mb={8} w="full" px={6} pt={4}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        pt={2}
        pb={2}
        maxW="1900"
        margin="0 auto"
        w="full"
        px={6}
        borderRadius="16px"
        bg="rgba(255, 255, 255, 0.88)"
        borderWidth="1px"
        borderColor="blackAlpha.100"
        boxShadow="0 10px 28px rgba(15, 23, 42, 0.08)"
        backdropFilter="blur(6px)"
      >
        <Flex gap={1}>
          <Link mr={1}>
            <RouterLink to="/tenants">
              <Text
                fontSize="sm"
                fontWeight="semibold"
                px={3}
                py={2}
                borderRadius="10px"
                _hover={{ bg: "blackAlpha.50" }}
              >
                Tenants
              </Text>
            </RouterLink>
          </Link>
          <Link mr={1}>
            <RouterLink to="/configuration">
              <Text
                fontSize="sm"
                fontWeight="semibold"
                px={3}
                py={2}
                borderRadius="10px"
                _hover={{ bg: "blackAlpha.50" }}
              >
                Configuration
              </Text>
            </RouterLink>
          </Link>
          <Link mr={1}>
            <RouterLink to="/wiki">
              <Text
                fontSize="sm"
                fontWeight="semibold"
                px={3}
                py={2}
                borderRadius="10px"
                _hover={{ bg: "blackAlpha.50" }}
              >
                Wiki
              </Text>
            </RouterLink>
          </Link>
        </Flex>
        <Flex justifyContent="center" alignItems="center">
          <Avatar size="sm" src={userPhoto} />
          <Button
            variant="ghost"
            mr={2}
            bg="transparent"
            _hover={{ bg: "transparent" }}
            _active={{ bg: "transparent" }}
            _focus={{ boxShadow: "none" }}
          >
            {activeAccount?.name}
          </Button>
          <SignOutButton />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default NavBar;
